import script from "./LegendSummaryPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegendSummaryPanel.vue?vue&type=script&setup=true&lang=ts"

import "./LegendSummaryPanel.vue?vue&type=style&index=0&id=f71a0110&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f71a0110"]])

export default __exports__